export default (axios, path = '/game/data') => ({
  findTeamRankingByGameId: async (gameId) => {
    return await axios.get(`${path}/${gameId}/team-ranking`)
  },
  findAllTeamTurnHistoryByTeamId: async (gameId) => {
    return await axios.get(`${path}/${gameId}/finance`)
  },
  async financeOverview(gameId) {
    return await axios.get(`${path}/${gameId}/finance-all`)
  },
})

